namespace('compass.hotel');

compass.require('compass.hotel.ReservationConfirmationWidget');
compass.requireLib('compass.util.format');

compass.hotel.StaySummaryWidget = compass.defineWidget(function StaySummaryWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var _settings = options;

	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	var _stays = _settings.roomTypeRecap;

	this.render = function(widgetElem) {
		if (compass.isRedesignEnabled()) {
			// Redesign layout
			var summaryCard = d.div({className:'staySummaryCard redesign'});
			
			summaryCard.append(drawSummaryHeader());
			
			for(var roomType=0; roomType<_stays.length; roomType++) {
				var stayItem = d.div({className:'stayItem'});
				stayItem.append(
					drawRoomType(_stays[roomType]),
					drawRoomNights(_stays[roomType]),
					drawTotal(_stays[roomType]),
					drawViewLink(_stays[roomType])
				);
				summaryCard.append(stayItem);
				
				if(roomType < _stays.length - 1) {
					summaryCard.append(d.div({className:'stayDivider'}));
				}
			}
			
			if(_stays.length > 1) {
				summaryCard.append(d.div({className:'stayDivider'}));
				summaryCard.append(drawAllTotal());
			}
			
			// Add reserve button for redesign
			var reserveButton = d.button({
				className: 'reserveButton button',
				type: 'button'
			}, 'Reserve');
			
			// Bind click event to trigger reservation
			reserveButton.activate(function() {
				me.trigger('StaySummaryWidget.reserveButtonClicked');
			});
			
			summaryCard.append(reserveButton);
			widgetElem.append(summaryCard);
		} else {
			// Legacy layout
			var summaryDiv = d.div({className:'summaryDiv'});
			summaryDiv.append(drawSummaryHeader());
			summaryDiv.append(d.div({className:'summaryDivider'}));
			for(var roomType=0; roomType<_stays.length; roomType++) {
				summaryDiv.append(
					drawRoomType(_stays[roomType]),
					drawRoomNights(_stays[roomType]),
					drawTotal(_stays[roomType]),
					drawViewLink(_stays[roomType]),
					d.div({className:'floatClear'}),
					d.div({className:'summaryDivider'})
				);
			}
			if(_stays.length > 1) {
				summaryDiv.append(drawAllTotal());
			}
			widgetElem.append(summaryDiv);
			var paperShadowDiv = d.div({className:'paperShadowDiv'});
			widgetElem.append(paperShadowDiv);
		}
	};

	function drawSummaryHeader(){
		if (compass.isRedesignEnabled()) {
			var totalRooms = 0;
			var totalNights = 0;
			for(var i=0; i<_stays.length; i++) {
				totalRooms += _stays[i].totals.rooms;
				totalNights += _stays[i].totals.roomNights;
			}
			
			return d.div({className:'summaryHeader redesign'},
				d.h3({className:'summaryTitle'}, 'Reservation Summary'),
				d.div({className:'summarySubtitle'}, totalRooms + ' reservations | ' + totalNights + ' nights')
			);
		} else {
			return d.div({className:'summaryHeader'}, 'Summary');
		}
	}

	function drawRoomType(roomType) {
		if (compass.isRedesignEnabled()) {
			return d.div({className: 'roomTypeName'}, roomType.roomType.roomTypeName);
		} else {
			return d.div({className: 'stayItem roomType'}, roomType.roomType.roomTypeName + ': ');
		}
	}

	function drawRoomNights(roomType) {
		var roomNightString = roomType.totals.rooms + ' rooms, ' + roomType.totals.roomNights + ' nights';
		if (compass.isRedesignEnabled()) {
			return d.div({className:'roomNightsStay'}, roomNightString);
		} else {
			return d.div({className:'stayItem roomNightsStay'}, roomNightString);
		}
	}

	function drawTotal(roomType) {
		var totalString = 'Estimated Total: ' + _cf(roomType.totals.cost + roomType.totals.serviceFee);
		if (compass.isRedesignEnabled()) {
			return d.div({className:'estimatedTotal'}, _cf(roomType.totals.cost + roomType.totals.serviceFee));
		} else {
			return d.div({className:'stayItem itemTotal'}, totalString);
		}
	}

	function drawAllTotal(){
		var totalCost = 0;
		for (var resType=0; resType<_stays.length; resType++) {
			totalCost = totalCost + _stays[resType].totals.cost + _stays[resType].totals.serviceFee;
		}
		var allTotalString = 'Total amount of stay: ' + _cf(totalCost);
		return d.div({className:'stayItem allItemTotal'}, allTotalString);
	}

	function drawViewLink(roomType){
		if (compass.isRedesignEnabled()) {
			var linkDiv = d.div({className:'viewDetailsLink'}, 
				d.a({href: "javascript:;"}, "Add more rooms at this hotel")
			);
		} else {
			var linkDiv = d.div({className:'resLinkDiv'}, d.a({
					href: "javascript:;"
				}, "View details &raquo;"));
		}

		jQuery(linkDiv).activate(function() {
			var popup = d.div();
			var resConfirmData = {
				WUID : 'ReservationDetails_' + _settings.WUID,
				meetingInfo : _settings.meetingInfo,
				stayRecap : roomType.stays,
				roomType : roomType.roomType,
				stays: roomType.stays,
				nights: roomType.nights,
				includeControls: false
				};

			var resConfirmWidget = new compass.hotel.ReservationConfirmationWidget(popup, resConfirmData);
			_confirmDialog = d.dialog({
				classes : 'confirmationDialog',
				modal : true,
				contents : popup,
				showParent : true
				});

		});
		return linkDiv;

	}

}, {
	WUID : 'defaultStaySummaryWidgetWUID',
	widgetName : 'StaySummaryWidget'
});

